import React from 'react'
import { Chip, Container, Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import NonStopFilterTooltip from './NonStopFilterTooltip'

interface AppliedFiltersChipProps {
    label: string | React.ReactNode
    onRemove: () => void
    logoLink?: string
    showNonStopTooltip?: boolean
    onTooltipDismiss?: () => void
}

const AppliedFiltersChip: React.FC<AppliedFiltersChipProps> = ({
    label,
    onRemove,
    logoLink,
    showNonStopTooltip = false,
    onTooltipDismiss
}) => {
    let ChipIcon: React.ReactNode = null
    if (logoLink) {
        ChipIcon = (
            <Image
                src={logoLink}
                height={16}
                width={16}
                alt={'logo'}
            />
        )
    }
    const labelStyle = { maxWidth: '170px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } as const
    const getModifiedLabel = (label: string | React.ReactNode) => {
       if (typeof label === 'string') {
         return <Typography variant='B3' className='' style={labelStyle}>{label}</Typography>
       }
       return <Container style={labelStyle}>{label}</Container>
    }
    return (
        <Container className="p-relative">
            <Chip
                label={getModifiedLabel(label)}
                showIcon={!!logoLink}
                Icon={ChipIcon}
                iconPosition={'left'}
                isSelected={true}
                isDismissible={true}
                onDismiss={onRemove}             
            />
            {showNonStopTooltip && (
                <NonStopFilterTooltip
                    isVisible={showNonStopTooltip}
                    onDismiss={onTooltipDismiss}
                    autoHideDuration={5000}
                />
            )}
        </Container>
    )
}

export default AppliedFiltersChip
